// extracted by mini-css-extract-plugin
export var actionText = "_pu-4";
export var container = "_pu-0";
export var leftSection = "_pu-1";
export var rightSection = "_pu-2";
export var settingsButton = "_pu-6";
export var settingsIcon = "_pu-7";
export var shortcut = "_pu-5";
export var shortcutGroup = "_pu-3";